import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ocr-sucess-page',
  templateUrl: './ocr-sucess-page.component.html',
  styleUrls: ['./ocr-sucess-page.component.css']
})
export class OcrSucessPageComponent implements OnInit {
  lotId: number;
  constructor(private activatedRoute: ActivatedRoute) {

    this.lotId = +(this.activatedRoute.snapshot.params.id);
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr-sucess-page/ocr-sucess-page.component.ts